import { render, staticRenderFns } from "./MultiTab.vue?vue&type=template&id=486747ff&scoped=true"
import script from "./MultiTab.vue?vue&type=script&lang=js"
export * from "./MultiTab.vue?vue&type=script&lang=js"
import style0 from "./MultiTab.vue?vue&type=style&index=0&id=486747ff&prod&lang=less"
import style1 from "./MultiTab.vue?vue&type=style&index=1&id=486747ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486747ff",
  null
  
)

export default component.exports